// extracted by mini-css-extract-plugin
module.exports = {"dailyCost":"PricesPageDailyCostWrapper_dailyCost__3xuGb","footerDiv":"PricesPageDailyCostWrapper_footerDiv__325bB","fontBeige":"PricesPageDailyCostWrapper_fontBeige__3XDjm"};